import React from 'react';
import { withRouter } from '../../services/withRoute';
import _ from 'lodash';
import '../../assets/scss/authenticator.scss';
import LoadingBar from '../components/global/loadingBar';
import Modal from '../components/modals';
import { ReactComponent as LoadingLight } from '../../assets/svg/loading-light.svg';
import { ReactComponent as TaskIcon } from '../../assets/svg/newtasks.svg';
import { ReactComponent as ExpandIcon } from '../../assets/svg/expand-leftbar-arrow.svg';
import { ReactComponent as HomeIcon } from '../../assets/svg/sidebar-home.svg';
import { ReactComponent as MCIcon } from '../../assets/svg/sidebar-mc.svg';
import { ReactComponent as EQIcon } from '../../assets/svg/sidebar-eq.svg';
import { ReactComponent as ShootsIcon } from '../../assets/svg/sidebar-shoots.svg';
import { ReactComponent as TeamsIcon } from '../../assets/svg/sidebar-teams.svg';
import { ReactComponent as ProjectsIcon } from '../../assets/svg/sidebar-projects.svg';
import { ReactComponent as OverviewIcon } from '../../assets/svg/sidebar-overview.svg';
import { ReactComponent as HDDIcon } from '../../assets/svg/sidebar-hd.svg';
import { ReactComponent as AtIcon } from '../../assets/svg/attendance-icon.svg';
import { ReactComponent as AssetsIcon } from '../../assets/svg/sidebar-assets.svg';
import { ReactComponent as AdminIcon } from '../../assets/svg/sidebar-admin.svg';
import { ReactComponent as HRIcon } from '../../assets/svg/sidebar-hr.svg';
import { ReactComponent as LogoutIcon } from '../../assets/svg/sidebar-logout.svg';
import { ReactComponent as DownIcon } from '../../assets/svg/sidebar-down-arrow.svg';
import { ReactComponent as CrewPlannerIcon } from '../../assets/svg/sidebar-crew-planner.svg';
import { ReactComponent as Deliverables } from '../../assets/svg/deliverables.svg';
import constants from '../../utils/constants';
import InputNew from '../components/global/inputNew';
import jwt_decode from 'jwt-decode';
import ReactTooltip from 'react-tooltip';
import Authenticator from '../../controllers/authenticator';
const getUserAccess = (vendorId) => {
	const global = constants.userAccess.global || {};
	const vendor = constants.userAccess.vendors?.[vendorId] || {};
	const merge = (key) => [...new Set([...(global[key] || []), ...(vendor[key] || [])])];
	return {
		adminUserIDs: merge('adminUserIDs'),
		hrModuleUserIds: merge('hrModuleUserIds'),
		assetsModuleUserIds: merge('assetsModuleUserIds'),
		crewPlannerUserIds: merge('crewPlannerUserIds'),
		adminToolsUserIds: merge('adminToolsUserIds'),
		attendanceExtraUserIds: merge('attendanceExtraUserIds'),
	};
};

class Layout extends Authenticator {
	constructor(props) {
		super(props);
		const access = getUserAccess(props.params.vendorID);
		this.state = {
			userDetails: {},
			getRemainingTime: props.getRemainingTime,
			showIdleModal: false,
			userName: null,
			passwordError: false,
			passwordErrorMessage: '',
			showPassword: false,
			isSubmitting: false,
			isUserNameEmail: true,
			errorMessage: '',
			...access,
			isUserDetailsLoading: true,
			isExpanded: false,
			isOverviewExpanded: false,
			isOverflown: false,
		};
		this.sideBarRef = React.createRef();
		this.linksContainerRef = React.createRef();
	}

	componentDidMount = async () => {
		document.addEventListener('mousedown', this.handleClickOutside);
		let usertoken = localStorage.getItem('usertoken');
		let decoded = await jwt_decode(usertoken);
		this.setState({
			userName: decoded.userName,
			userId: decoded.user_id,
		});
		this.getUserDetails();
		if (localStorage.getItem('isIdle')) {
			this.setState({
				showIdleModal: true,
			});
		}
	};
	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}
	componentDidUpdate = (prevProps, prevState) => {
		if (
			prevProps.getRemainingTime !== this.props.getRemainingTime &&
			this.props.getRemainingTime == 0
		) {
			this.setState(
				{
					getRemainingTime: 0,
					showIdleModal: true,
				},
				() => {
					localStorage.setItem('isIdle', true);
				},
			);
		}
	};
	checkOverflow = () => {
		if (
			this.linksContainerRef.current &&
			this.linksContainerRef.current.scrollHeight >
				this.linksContainerRef.current.clientHeight
		) {
			this.setState({
				isOverflown: true,
			});
		} else {
			this.setState({
				isOverflown: false,
			});
		}
	};
	renderToolTip = (id) => {
		return (
			<ReactTooltip
				id={id}
				place="right"
				effect="solid"
				className={'react-tool-tip-text'}
				type={'light'} //{this.state.currentTheme === 'theme-dark' ? 'light' : 'dark'}
			/>
		);
	};
	logoutUser = () => {
		localStorage.clear('usertoken');
		window.open('https://vendors.huemn.com', '_self');
	};
	validateInput = (e) => {
		let errorName = e.target.name + 'Error';
		let errorMessage = e.target.name + 'ErrorMessage';

		this.setState({
			[e.target.name]: e.target.value,
			[errorName]: false,
			[errorMessage]: '',
			errorMessage: '',
		});
	};
	handleSubmit = async () => {
		if (this.state.userDetails.is2FAConfigured && this.state.userDetails.is2FAEnabled) {
			if (
				this.state.authenticatorAppCode != '' &&
				this.state.authenticatorAppCodeError === false
			) {
				this.setState({ isSubmitting: true });
				try {
					let response = await this.userLoginWithPassword(
						this.state.userDetails.email,
						this.state.password,
						this.state.authenticatorAppCode,
						true,
					);
				} catch (err) {
					this.setState({ errorMessage: 'Check your Internet' });
				}
				this.setState({ isSubmitting: false });
			} else {
				if (this.state.authenticatorAppCode === '') {
					this.setState({
						authenticatorAppCodeError: true,
						authenticatorAppCodeErrorMessage: 'Required Field',
					});
				}
			}
		} else {
			if (this.state.password != '' && this.state.passwordError === false) {
				this.setState({ isSubmitting: true });
				try {
					let response = await this.userLoginWithPassword(
						this.state.userDetails.email,
						this.state.password,
						null,
						true,
					);
				} catch (err) {
					this.setState({ errorMessage: 'Check your Internet' });
				}
				this.setState({ isSubmitting: false });
			} else {
				if (this.state.password === '') {
					this.setState({
						passwordError: true,
						passwordErrorMessage: 'Required Field',
					});
				}
			}
		}
	};
	onKeyDown(event) {
		if (event.keyCode === 13) {
			if (!this.state.isSubmitting) this.handleSubmit();
		}
	}
	handleClickOutside = (event) => {
		if (this.sideBarRef.current && !this.sideBarRef.current.contains(event.target)) {
			this.setState({
				isExpanded: false,
			});
		}
	};
	toggleExpanded = (e, type = null) => {
		if (type == null) {
			this.setState({
				isExpanded: !this.state.isExpanded,
			});
		} else {
			this.setState({
				isExpanded: type,
			});
		}
	};
	render() {
		return (
			<>
				<div
					className={
						this.state.isExpanded
							? 'header-left-bar-img-container wide-left-bar-container'
							: 'header-left-bar-img-container'
					}
					ref={this.sideBarRef}
				>
					{this.state.isExpanded ? '' : this.renderToolTip('left-bar-brand')}
					<div
						className={
							'header-left-bar-expand-icn' +
							(this.state.isExpanded === true ? ' expanded-left-bar-icn' : '')
						}
						onClick={(e) => this.toggleExpanded(e)}
					>
						<ExpandIcon />
					</div>
					<div className="header-left-bar-container">
						<div className="header-left-bar-top-container">
							{this.state.isExpanded ? '' : this.renderToolTip('left-bar-mc')}
							{this.state.isExpanded ? '' : this.renderToolTip('left-bar-eq')}
							{this.state.isExpanded ? '' : this.renderToolTip('left-bar-shoots')}
							{this.state.isExpanded ? '' : this.renderToolTip('left-bar-teams')}
							{this.state.isExpanded ? '' : this.renderToolTip('left-bar-projects')}
							{this.state.isExpanded ? '' : this.renderToolTip('left-bar-tasks')}
							{this.state.isExpanded ? '' : this.renderToolTip('left-bar-hdd')}
							<div
								className={
									'top-brand-container' +
									(this.state.isExpanded ? ' expanded' : '')
								}
								style={
									this.state.isOverflown === true
										? { borderBottom: '2px solid #121212' }
										: {}
								}
							>
								<div className="top-inner-brand-wrapper">
									<span
										className="brand-icon"
										data-tip={this.props.params.vendorID}
										data-for="left-bar-brand"
									></span>
									<span
										className={
											'brand-title' +
											(this.state.isExpanded === true ? ' show' : '')
										}
									>
										{this.props.params.vendorID}
									</span>
								</div>
							</div>
							<div className="middle-nav-item-container" ref={this.linksContainerRef}>
								{_.indexOf(this.state.adminUserIDs, this.state.userId) >= 0 ? (
									<>
										{this.state.isExpanded
											? ''
											: this.renderToolTip('left-bar-home')}
										<div
											className={
												'nav-item-container' +
												(this.props.locations.pathname.split('/')[2] ===
												'monthly-overview-graph'
													? ' active'
													: '')
											}
											onClick={(e) => {
												if (
													this.props.locations.pathname.split('/')[2] !==
													'monthly-overview-graph'
												) {
													this.props.navigate(
														`/${this.props.params.vendorID}/monthly-overview-graph`,
													);
												}
											}}
											data-tip="Dashboard"
											data-for="left-bar-home"
										>
											<span className="nav-icn">
												<HomeIcon />
											</span>
											<span
												className={
													'nav-item-inner-container' +
													(this.state.isExpanded === true ? ' show' : '')
												}
											>
												<span className="nav-link-text">Dashboard</span>
											</span>
										</div>
									</>
								) : null}
								<div
									className={
										'nav-item-container' +
										(this.props.locations.pathname.split('/')[2] ===
										'memory-cards'
											? ' active'
											: '')
									}
									onClick={(e) => {
										if (
											this.props.locations.pathname.split('/')[2] !==
											'memory-cards'
										) {
											this.props.navigate(
												`/${this.props.params.vendorID}/memory-cards`,
											);
										}
									}}
									data-tip="Memory Cards"
									data-for="left-bar-mc"
								>
									<span className="nav-icn">
										<MCIcon />
									</span>
									<span
										className={
											'nav-item-inner-container' +
											(this.state.isExpanded === true ? ' show' : '')
										}
									>
										<span className="nav-link-text">Memory Cards</span>
									</span>
								</div>
								<div
									className={
										'nav-item-container' +
										(this.props.locations.pathname.split('/')[2] ===
										'equipments'
											? ' active'
											: '')
									}
									onClick={(e) => {
										if (
											this.props.locations.pathname.split('/')[2] !==
											'equipments'
										) {
											this.props.navigate(
												`/${this.props.params.vendorID}/equipments`,
											);
										}
									}}
									data-tip="Equipments"
									data-for="left-bar-eq"
								>
									<span className="nav-icn">
										<EQIcon />
									</span>
									<span
										className={
											'nav-item-inner-container' +
											(this.state.isExpanded === true ? ' show' : '')
										}
									>
										<span className="nav-link-text">Equipments</span>
									</span>
								</div>
								<div
									className={
										'nav-item-container' +
										(this.props.locations.pathname.split('/')[2] === 'shoots'
											? ' active'
											: '')
									}
									onClick={(e) =>
										this.props.navigate(`/${this.props.params.vendorID}/shoots`)
									}
									data-tip="Shoots"
									data-for="left-bar-shoots"
								>
									<span className="nav-icn nav-icn-no-fill">
										<ShootsIcon />
									</span>
									<span
										className={
											'nav-item-inner-container' +
											(this.state.isExpanded === true ? ' show' : '')
										}
									>
										<span className="nav-link-text">Shoots</span>
									</span>
								</div>
								<div
									className={
										'nav-item-container' +
										(this.props.locations.pathname.split('/')[2] ===
										'tenant-users'
											? ' active'
											: '')
									}
									onClick={(e) =>
										this.props.navigate(
											`/${this.props.params.vendorID}/tenant-users`,
										)
									}
									data-tip="Teams"
									data-for="left-bar-teams"
								>
									<span className="nav-icn">
										<TeamsIcon />
									</span>
									<span
										className={
											'nav-item-inner-container' +
											(this.state.isExpanded === true ? ' show' : '')
										}
									>
										<span className="nav-link-text">Teams</span>
									</span>
								</div>
								{this.props.params.vendorID === 'HYD01' &&
								(_.indexOf(this.state.adminUserIDs, this.state.userId) >= 0 ||
								_.indexOf(this.state.crewPlannerUserIds, this.state.userId) >= 0) ? (
									<>
									{this.state.isExpanded ? '' : this.renderToolTip('left-bar-crew-planner')}
									<div
										className={
											'nav-item-container' +
											(this.props.locations.pathname.split('/')[2] === 'crew-planner'
												? ' active'
												: '')
										}
										onClick={(e) =>
											this.props.navigate(`/${this.props.params.vendorID}/crew-planner`)
										}
										data-tip="Crew Planner"
										data-for="left-bar-crew-planner"
									>
										<span className="nav-icn nav-icn-no-fill nav-icn-stroke-only">
											<CrewPlannerIcon />
										</span>
										<span
											className={
												'nav-item-inner-container' +
												(this.state.isExpanded === true ? ' show' : '')
											}
										>
											<span className="nav-link-text">Crew Planner</span>
										</span>
									</div>
									</>
								) : null}
								<div
									className={
										'nav-item-container' +
										(this.props.locations.pathname.split('/')[2] ===
										'deliverables'
											? ' active'
											: '')
									}
									onClick={(e) =>
										this.props.navigate(
											`/${this.props.params.vendorID}/deliverables`,
										)
									}
									data-tip="Deliverables"
									data-for="left-bar-projects"
								>
									<span className="nav-icn nav-icn-no-fill nav-icn-stroke-only">
										<Deliverables />
									</span>
									<span
										className={
											'nav-item-inner-container' +
											(this.state.isExpanded === true ? ' show' : '')
										}
									>
										<span className="nav-link-text">Deliverables</span>
									</span>
								</div>

								<div
									className={
										'nav-item-container' +
										(this.props.locations.pathname.split('/')[2] === 'projects'
											? ' active'
											: '')
									}
									onClick={(e) =>
										this.props.navigate(
											`/${this.props.params.vendorID}/projects`,
										)
									}
									data-tip="Projects"
									data-for="left-bar-projects"
								>
									<span className="nav-icn nav-icn-no-fill nav-icn-stroke-only">
										<ProjectsIcon />
									</span>
									<span
										className={
											'nav-item-inner-container' +
											(this.state.isExpanded === true ? ' show' : '')
										}
									>
										<span className="nav-link-text">Projects</span>
									</span>
								</div>
								<div
									className={
										'nav-item-container' +
										(this.props.locations.pathname.split('/')[2] === 'tasks'
											? ' active'
											: '')
									}
									onClick={(e) =>
										this.props.navigate(`/${this.props.params.vendorID}/tasks`)
									}
									data-tip="Tasks"
									data-for="left-bar-tasks"
								>
									<span className="nav-icn nav-icn-no-fill nav-icn-stroke-only">
										<TaskIcon width={20} height={20} />
									</span>
									<span
										className={
											'nav-item-inner-container' +
											(this.state.isExpanded === true ? ' show' : '')
										}
									>
										<span className="nav-link-text">Tasks</span>
									</span>
								</div>
								{_.indexOf(this.state.adminUserIDs, this.state.userId) >= 0 ? (
									<>
										{this.state.isExpanded
											? ''
											: this.renderToolTip('left-bar-overview')}
										<div
											className={
												'nav-item-container' +
												(this.props.locations.pathname.split('/')[2] ===
													'shoots-overview' ||
												this.props.locations.pathname.split('/')[2] ===
													'shoots-tenant-users'
													? ' active'
													: '')
											}
											onClick={() =>
												this.setState({
													isOverviewExpanded:
														!this.state.isOverviewExpanded,
												})
											}
											data-tip="Overview"
											data-for="left-bar-overview"
										>
											<span className="nav-icn">
												<OverviewIcon />
											</span>
											<span
												className={
													'nav-item-inner-container' +
													(this.state.isExpanded === true ? ' show' : '')
												}
											>
												<span className="nav-link-text">Overview</span>
												{this.state.isExpanded === true ? (
													<span
														className={
															'nav-link-drop-icn' +
															(this.state.isOverviewExpanded === true
																? ' expanded'
																: '')
														}
													>
														<DownIcon />
													</span>
												) : null}
											</span>
										</div>
										{this.state.isOverviewExpanded === true &&
										this.state.isExpanded === true ? (
											<div className="nav-middle-sub-container">
												<div
													className={
														'nav-sub-item-container' +
														(this.props.locations.pathname.split(
															'/',
														)[2] === 'shoots-overview'
															? ' active'
															: '')
													}
													onClick={(e) =>
														this.props.navigate(
															`/${this.props.params.vendorID}/shoots-overview`,
														)
													}
												>
													Shoots Overview
												</div>
												<div
													className={
														'nav-sub-item-container' +
														(this.props.locations.pathname.split(
															'/',
														)[2] === 'shoots-tenant-users'
															? ' active'
															: '')
													}
													onClick={(e) =>
														this.props.navigate(
															`/${this.props.params.vendorID}/shoots-tenant-users`,
														)
													}
												>
													Shooters Overview
												</div>
											</div>
										) : null}
									</>
								) : null}
								<div
									className={
										'nav-item-container' +
										(this.props.locations.pathname.split('/')[2] ===
										'harddrives'
											? ' active'
											: '')
									}
									onClick={(e) =>
										this.props.navigate(
											`/${this.props.params.vendorID}/harddrives`,
										)
									}
									data-tip="Hard Drives"
									data-for="left-bar-hdd"
								>
									<span className="nav-icn nav-icn-no-fill nav-icn-stroke-only">
										<HDDIcon />
									</span>
									<span
										className={
											'nav-item-inner-container' +
											(this.state.isExpanded === true ? ' show' : '')
										}
									>
										<span className="nav-link-text">Hard Drives</span>
									</span>
								</div>
								{_.indexOf(this.state.adminUserIDs, this.state.userId) >= 0 ||
								_.indexOf(this.state.assetsModuleUserIds, this.state.userId) >=
									0 ? (
									<>
										{this.state.isExpanded
											? ''
											: this.renderToolTip('left-bar-assets')}
										<div
											className={
												'nav-item-container' +
												(this.props.locations.pathname.split('/')[2] ===
												'assets'
													? ' active'
													: '')
											}
											onClick={(e) =>
												this.props.navigate(
													`/${this.props.params.vendorID}/assets`,
												)
											}
											data-tip="Assets"
											data-for="left-bar-assets"
										>
											<span className="nav-icn">
												<AssetsIcon />
											</span>
											<span
												className={
													'nav-item-inner-container' +
													(this.state.isExpanded === true ? ' show' : '')
												}
											>
												<span className="nav-link-text">Assets</span>
											</span>
										</div>
									</>
								) : null}
								{_.indexOf(this.state.adminUserIDs, this.state.userId) >= 0 ||
								_.indexOf(this.state.adminToolsUserIds, this.state.userId) >= 0 ? (
									<>
										{this.state.isExpanded
											? ''
											: this.renderToolTip('left-bar-admin')}
										<div
											className={
												'nav-item-container' +
												(this.props.locations.pathname.split('/')[2] ===
												'admin-tools'
													? ' active'
													: '')
											}
											onClick={(e) =>
												this.props.navigate(
													`/${this.props.params.vendorID}/admin-tools/remap-equipment`,
												)
											}
											data-tip="Admin"
											data-for="left-bar-admin"
										>
											<span className="nav-icn">
												<AdminIcon />
											</span>
											<span
												className={
													'nav-item-inner-container' +
													(this.state.isExpanded === true ? ' show' : '')
												}
											>
												<span className="nav-link-text">Admin</span>
											</span>
										</div>
									</>
								) : null}
								{_.indexOf(this.state.adminUserIDs, this.state.userId) >= 0 ||
								_.indexOf(this.state.hrModuleUserIds, this.state.userId) >= 0 ||
								_.indexOf(this.state.attendanceExtraUserIds, this.state.userId) >= 0 ? (
									<>
										{this.state.isExpanded
											? ''
											: this.renderToolTip('left-bar-hr')}
										<div
											className={
												'nav-item-container' +
												(this.props.locations.pathname.split('/')[2] ===
												'attendance'
													? ' active'
													: '')
											}
											onClick={(e) =>
												this.props.navigate(
													`/${this.props.params.vendorID}/attendance`,
												)
											}
											data-tip="Attendance"
											data-for="left-bar-hr"
										>
											<span className="nav-icn">
												<AtIcon />
											</span>
											<span
												className={
													'nav-item-inner-container' +
													(this.state.isExpanded === true ? ' show' : '')
												}
											>
												<span className="nav-link-text">Attendance</span>
											</span>
										</div>
									</>
								) : null}
								{_.indexOf(this.state.adminUserIDs, this.state.userId) >= 0 ||
								_.indexOf(this.state.hrModuleUserIds, this.state.userId) >= 0 ? (
									<>
										{this.state.isExpanded
											? ''
											: this.renderToolTip('left-bar-hr')}
										<div
											className={
												'nav-item-container' +
												(this.props.locations.pathname.split('/')[2] ===
												'hr'
													? ' active'
													: '')
											}
											onClick={(e) =>
												this.props.navigate(
													`/${this.props.params.vendorID}/hr`,
												)
											}
											data-tip="HR"
											data-for="left-bar-hr"
										>
											<span className="nav-icn">
												<HRIcon />
											</span>
											<span
												className={
													'nav-item-inner-container' +
													(this.state.isExpanded === true ? ' show' : '')
												}
											>
												<span className="nav-link-text">HR</span>
											</span>
										</div>
									</>
								) : null}
							</div>
							<div
								className="header-left-bar-bottom-container"
								style={
									this.state.isOverflown === true
										? { borderTop: '2px solid #121212' }
										: {}
								}
							>
								{this.state.isExpanded === false &&
								this.state.userDetails?.firstName
									? this.renderToolTip('left-bar-profile')
									: ''}
								<span
									className="display-img"
									data-tip={this.state.userDetails.firstName}
									data-for="left-bar-profile"
								>
									{_.size(this.state.userDetails?.firstName) > 0
										? this.state.userDetails.firstName[0] +
										  (_.size(this.state.userDetails?.lastName) > 0
												? this.state.userDetails.lastName[0]
												: this.state.userDetails.firstName[1])
										: ''}
									{/* <img /> */}
								</span>
								<span
									className={
										'left-bar-profile-left' +
										(this.state.isExpanded ? ' show' : '')
									}
								>
									<span className="profile-nav-text">
										{this.state.userDetails.firstName}
									</span>
									<span
										className="profile-logout-icn"
										onClick={() => this.logoutUser()}
									>
										<LogoutIcon />
									</span>
								</span>
							</div>
						</div>
					</div>
				</div>
				{/* <div className="sidebar">
					<span className="side-bar-header">{this.props.params.vendorID}</span>
					{_.indexOf(this.state.adminUserIDs, this.state.userId) >= 0 ? (
						<a
							className={
								this.props.locations.pathname.split('/')[2] ===
								'monthly-overview-graph'
									? 'active'
									: ''
							}
							onClick={(e) => {
								if (
									this.props.locations.pathname.split('/')[2] !==
									'monthly-overview-graph'
								) {
									this.props.navigate(
										`/${this.props.params.vendorID}/monthly-overview-graph`,
									);
								}
							}}
						>
							Dashboard
						</a>
					) : (
						''
					)}
					<a
						className={
							this.props.locations.pathname.split('/')[2] === 'memory-cards'
								? 'active'
								: ''
						}
						onClick={(e) => {
							if (this.props.locations.pathname.split('/')[2] !== 'memory-cards') {
								this.props.navigate(`/${this.props.params.vendorID}/memory-cards`);
							}
						}}
					>
						MC
					</a>
					<a
						className={
							this.props.locations.pathname.split('/')[2] === 'equipments'
								? 'active'
								: ''
						}
						onClick={(e) => {
							if (this.props.locations.pathname.split('/')[2] !== 'equipments') {
								this.props.navigate(`/${this.props.params.vendorID}/equipments`);
							}
						}}
					>
						Equipment
					</a>
					<a
						className={
							this.props.locations.pathname.split('/')[2] === 'shoots' ? 'active' : ''
						}
						onClick={(e) =>
							this.props.navigate(`/${this.props.params.vendorID}/shoots`)
						}
					>
						Shoots
					</a>
					<a
						className={
							this.props.locations.pathname.split('/')[2] === 'tenant-users'
								? 'active'
								: ''
						}
						onClick={(e) =>
							this.props.navigate(`/${this.props.params.vendorID}/tenant-users`)
						}
					>
						Team
					</a>
					<a
						className={
							this.props.locations.pathname.split('/')[2] === 'projects'
								? 'active'
								: ''
						}
						onClick={(e) =>
							this.props.navigate(`/${this.props.params.vendorID}/projects`)
						}
					>
						Projects
					</a>
					<a
						className={
							this.props.locations.pathname.split('/')[2] === 'harddrives'
								? 'active'
								: ''
						}
						onClick={(e) =>
							this.props.navigate(`/${this.props.params.vendorID}/harddrives`)
						}
					>
						Hard Drives
					</a>

					{_.indexOf(this.state.adminUserIDs, this.state.userId) >= 0 ? (
						<a
							className={
								this.props.locations.pathname.split('/')[2] === 'shoots-overview'
									? 'active'
									: ''
							}
							onClick={(e) =>
								this.props.navigate(
									`/${this.props.params.vendorID}/shoots-overview`,
								)
							}
						>
							Shoots Overview
						</a>
					) : (
						''
					)}
					{_.indexOf(this.state.adminUserIDs, this.state.userId) >= 0 ? (
						<a
							className={
								this.props.locations.pathname.split('/')[2] ===
								'shoots-tenant-users'
									? 'active'
									: ''
							}
							onClick={(e) =>
								this.props.navigate(
									`/${this.props.params.vendorID}/shoots-tenant-users`,
								)
							}
						>
							Shooters Overview
						</a>
					) : (
						''
					)}
					{_.indexOf(this.state.adminUserIDs, this.state.userId) >= 0 ||
					this.state.userId === '63edcb9ef634d01c719a621e' ||
					this.state.userId === '641c0f33763b4a3b079ba857' ? (
						<a
							className={
								this.props.locations.pathname.split('/')[2] === 'admin-tools'
									? 'active'
									: ''
							}
							onClick={(e) =>
								this.props.navigate(
									`/${this.props.params.vendorID}/admin-tools/remap-equipment`,
								)
							}
						>
							Admin
						</a>
					) : (
						''
					)}
					{_.indexOf(this.state.adminUserIDs, this.state.userId) >= 0 ? (
						<a
							className={
								this.props.locations.pathname.split('/')[2] === 'hr' ? 'active' : ''
							}
							onClick={(e) =>
								this.props.navigate(`/${this.props.params.vendorID}/hr`)
							}
						>
							HR
						</a>
					) : (
						''
					)}
					{_.indexOf(this.state.adminUserIDs, this.state.userId) >= 0 ? (
						<a
							className={
								this.props.locations.pathname.split('/')[2] === 'assets'
									? 'active'
									: ''
							}
							onClick={(e) =>
								this.props.navigate(`/${this.props.params.vendorID}/assets`)
							}
						>
							Assets
						</a>
					) : (
						''
					)}

					<a
						style={{
							position: 'fixed',
							bottom: '80px',
							width: '80px',
						}}
					>
						{this.state.userDetails.firstName}{' '}
					</a>

					<a
						style={{
							position: 'fixed',
							bottom: '0px',
							width: '80px',
						}}
						onClick={() => this.logoutUser()}
					>
						Logout
					</a>
				</div> */}
				{this.state.showIdleModal ? '' : this.props.children}
				<Modal show={this.state.showIdleModal} modalType={'center'}>
					{this.state.isUserDetailsLoading ? (
						<div
							style={{
								width: '100vw',
								height: '100vh',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<LoadingBar />
						</div>
					) : (
						<div
							style={{
								width: '100vw',
								height: '100vh',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<div
								className="idle-container"
								style={{ display: 'flex', flexDirection: 'column' }}
							>
								<div className="idle-text">
									Hi,{this.state.userName}
									<br />
									<br />
									Your account has been idle for a longer time,please enter
									password to continue
								</div>
								<div className="input-container">
									<InputNew
										classname={'input-with-floating-label'}
										placeholder={'Password'}
										type={this.state.showPassword ? 'text' : 'password'}
										label={'Password'}
										name={'password'}
										onChange={(e) => this.validateInput(e)}
										value={this.state.password}
										autoFocus={this.state.ispasswordEmail}
										isInputError={this.state.passwordError}
										errorMessage={this.state.passwordErrorMessage}
										onKeyDown={(e) => this.onKeyDown(e)}
									/>
									<p
										className={'forgot-password-text'}
										onClick={(e) => this.logoutUser()}
										style={{ marginTop: '5px' }}
									>
										Try with another account?
									</p>
								</div>
								{this.state.userDetails.is2FAConfigured &&
								this.state.userDetails.is2FAEnabled ? (
									<div style={{ display: 'flex', flexDirection: 'column' }}>
										<InputNew
											label={'Two Factor Authentication (2FA)'}
											type={'text'}
											value={this.state.authenticatorAppCode}
											onChange={(e) => this.onInputChange2FA(e)}
											autoFocus={true}
											name="authenticatorAppCode"
											isInputError={this.state.authenticatorAppCodeError}
											errorMessage={
												this.state.authenticatorAppCodeErrorMessage
											}
											placeholder="Authenticator App Code"
										/>
									</div>
								) : (
									''
								)}

								<div
									className="form-submit"
									style={{
										backgroundColor:
											this.state.userName !== '' && this.state.password !== ''
												? '#696FF3'
												: 'rgba(210, 211, 214, 1)',
										color:
											this.state.userName !== '' && this.state.password !== ''
												? '#ffffff'
												: '#b0b0b0',
									}}
									onClick={() => {
										if (!this.state.isSubmitting) this.handleSubmit();
									}}
								>
									<p>
										{this.state.isSubmitting === true ? (
											<div className="loading-icon d-flex">
												<LoadingLight />
											</div>
										) : (
											'Unlock'
										)}
									</p>
								</div>
								<p className={'error-message'}>{this.state.errorMessage}</p>
							</div>
						</div>
					)}
				</Modal>
			</>
		);
	}
}

export default withRouter(Layout);
